import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export const getLoggedInUserProfile = () =>
  apiClient.get(`${REST_API_BASE_URL}/profile`);

export const getAllUsers = () => apiClient.get(`${REST_API_BASE_URL}/users`);

export const getUserById = (id: number) =>
  apiClient.get(`${REST_API_BASE_URL}/users/${id}`);

export const updateUser = (
  id: number,
  body: { enabled?: boolean; roleName?: string; reason?: string },
) => apiClient.put(`${REST_API_BASE_URL}/users/${id}`, body);

export const getUsersByAccount = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}/users`);

export const getUsersByMembershipGroups = (membershipid) =>
  apiClient.get(`${REST_API_BASE_URL}/membership/${membershipid}/groups/users`);

export default apiClient;
